import { render, staticRenderFns } from "./BloodResultsDataTable.vue?vue&type=template&id=0a0fad91"
import script from "./BloodResultsDataTable.vue?vue&type=script&lang=js"
export * from "./BloodResultsDataTable.vue?vue&type=script&lang=js"
import style0 from "./BloodResultsDataTable.vue?vue&type=style&index=0&id=0a0fad91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports